import React from 'react';
import './index.css';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import Home from './Pages/Index';
import Login from './Pages/Login';
import CompanyView from './Pages/CompanyView';
import StudentTable from './Pages/StudentView';
import PrivateRoute from './Components/PrivateRoute';
import Grades from './Pages/Grades';


function App() {
  return (
    <>
      <Routes>
        {/* Public route */}
        <Route path="/" element={<Login />} />

        {/* Protected routes */}
        <Route element={<PrivateRoute />}>
          <Route path="/index" element={<Home />}>
            <Route index element={<Navigate to="companydetails" replace />} />
            <Route path="companydetails" element={<CompanyView />} />
            <Route path="studentdetails" element={<StudentTable />} />
            <Route path='grades' element = {<Grades/>} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
